/* Lucide-style inline SVG icons — v6.1 portal HTML 충실 이식 */
import { JSX } from 'react'

const ICON_PROPS = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
}

export const ICONS: Record<string, (size?: number) => JSX.Element> = {
  CalendarClock: (s = 28) => (
    <svg {...ICON_PROPS} width={s} height={s}>
      <path d="M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6"/>
      <path d="M16 2v4"/><path d="M8 2v4"/><path d="M3 10h18"/>
      <circle cx="17" cy="17" r="5"/>
      <path d="M17 14v3l1.5 1.5"/>
    </svg>
  ),
  Briefcase: (s = 28) => (
    <svg {...ICON_PROPS} width={s} height={s}>
      <rect x="2" y="7" width="20" height="14" rx="2"/>
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
    </svg>
  ),
  HardHat: (s = 28) => (
    <svg {...ICON_PROPS} width={s} height={s}>
      <path d="M2 18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1z"/>
      <path d="M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5"/>
      <path d="M4 15v-3a6 6 0 0 1 6-6"/>
      <path d="M14 6a6 6 0 0 1 6 6v3"/>
    </svg>
  ),
  Coins: (s = 28) => (
    <svg {...ICON_PROPS} width={s} height={s}>
      <circle cx="8" cy="8" r="6"/>
      <path d="M18.09 10.37A6 6 0 1 1 10.34 18"/>
      <path d="M7 6h1v4"/>
      <path d="m16.71 13.88.7.71-2.82 2.82"/>
    </svg>
  ),
  Code2: (s = 28) => (
    <svg {...ICON_PROPS} width={s} height={s}>
      <path d="m18 16 4-4-4-4"/>
      <path d="m6 8-4 4 4 4"/>
      <path d="m14.5 4-5 16"/>
    </svg>
  ),
  BookOpen: (s = 28) => (
    <svg {...ICON_PROPS} width={s} height={s}>
      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
      <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
    </svg>
  ),
  Home: (s = 28) => (
    <svg {...ICON_PROPS} width={s} height={s}>
      <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
      <polyline points="9 22 9 12 15 12 15 22"/>
    </svg>
  ),
  GraduationCap: (s = 28) => (
    <svg {...ICON_PROPS} width={s} height={s}>
      <path d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z"/>
      <path d="M22 10v6"/>
      <path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"/>
    </svg>
  ),
  HeartHandshake: (s = 28) => (
    <svg {...ICON_PROPS} width={s} height={s}>
      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>
    </svg>
  ),
  Layers: (s = 28) => (
    <svg {...ICON_PROPS} width={s} height={s}>
      <path d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0l8.57-3.908a1 1 0 0 0 0-1.832Z"/>
      <path d="m22 12.5-9.4 4.28a2 2 0 0 1-1.66 0L1.5 12.5"/>
      <path d="m22 17.5-9.4 4.28a2 2 0 0 1-1.66 0L1.5 17.5"/>
    </svg>
  ),
  Search: (s = 20) => (
    <svg {...ICON_PROPS} width={s} height={s}>
      <circle cx="11" cy="11" r="8"/>
      <path d="m21 21-4.3-4.3"/>
    </svg>
  ),
  /* v2.4 (2026-05-12): schema-card 좌상단 schema vs view 구분용 인라인 아이콘 */
  Database: (s = 14) => (
    <svg {...ICON_PROPS} width={s} height={s}>
      <ellipse cx="12" cy="5" rx="9" ry="3"/>
      <path d="M3 5v14a9 3 0 0 0 18 0V5"/>
      <path d="M3 12a9 3 0 0 0 18 0"/>
    </svg>
  ),
  Eye: (s = 14) => (
    <svg {...ICON_PROPS} width={s} height={s}>
      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  ),
}
